import { Component, AfterContentInit, OnInit, Inject, APP_INITIALIZER, ApplicationInitStatus } from '@angular/core';
import { TrackService } from 'src/app/services/track/track.service';
import { EmarsysService } from 'src/app/services/track/emarsys.service';
import { RestrictionService } from 'src/app/services/domain/restriction.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { Language } from 'src/app/tools/language/language';
import { SiteTitle } from 'src/app/enums/sitetitle.enum';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterContentInit, OnInit {
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  constructor(
    @Inject(APP_INITIALIZER) public appInit: ApplicationInitStatus,
    private _track: TrackService,
    private _emarsys: EmarsysService,
    private _titleService: Title,
    private _globals: GlobalsService,
    private _restriction: RestrictionService
  ) {}

  ngOnInit(): void {
    this._restriction.setRestrictions();
    this.setTitle();
  }

  ngAfterContentInit() {
    this._track.loadTrack();
    this._emarsys.loadEmarsys();
  }

  setTitle(): void {
    let site: string = this._globals.getSystem().site;
    let lang: any = Language.currentLanguage.lenid;
    this._titleService.setTitle(SiteTitle[`${site}${lang}`]);
    this.updateFavIcon(site);
  }

  updateFavIcon(site: string) {
    switch (site) {
      case 'ltk':
        this.favIcon.href = 'https://d3tmfelegj51yl.cloudfront.net/brand/ltk/favicon.ico';
        break;
      default:
        this.favIcon.href = 'https://d3tmfelegj51yl.cloudfront.net/brand/wt/favicon.ico';
        break;
    }
  }
}
